import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom'; // Import Link for navigation
import '../styles_v2.css';
import config from "./config";

const HomePage = () => {
  const [hovered, setHovered] = useState(null);
  const [backgroundImage, setBackgroundImage] = useState('');
  const [imageError, setImageError] = useState('');
  const [imageFilename, setImageFilename] = useState('');

  useEffect(() => {
    // Fetch the signed URLs from the backend
    const fetchSignedUrls = async () => {
      try {
        const response = await fetch(`${config.API_BASE_URL}/get-signed-urls-photos-home`);
        const data = await response.json();

        // Select a random image from the signed URLs
        const randomIndex = Math.floor(Math.random() * data.length);
        const selectedImage = data[randomIndex].midres_url;  // Use the presigned URL (midres_url)
        setBackgroundImage(selectedImage);

        // Extract filename from URL
        const filename = selectedImage.split('/').pop().split('?')[0]; // Removes query params if present
        setImageFilename(filename);

        // Check if the image loads successfully
        const img = new Image();
        img.src = selectedImage;
        img.onload = () => {
          setImageError('');
        };
        img.onerror = () => {
          setImageError('Image failed to load: ' + filename);
        };
      } catch (error) {
        console.error('Error fetching signed URLs:', error);
        setImageError('Failed to load background image.');
      }
    };

    fetchSignedUrls();
  }, []);

  const containerStyle = {
    backgroundImage: `url(${backgroundImage})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    width: '100vw',
    height: '100vh',
    margin: 0,
    padding: 0,
    overflow: 'hidden',
    position: 'relative', // Allows absolute positioning of header and links
  };

  const headerStyle = {
    position: 'absolute',
    top: '8%',
    left: '50%',
    transform: 'translateX(-50%)',
    color: 'white',
    padding: '10px 20px',
    fontSize: '36px',
    textAlign: 'center',
    width: '100%',
  };

  const linkContainerStyle = {
    position: 'absolute',
    top: '40%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    display: 'flex',
    justifyContent: 'center',
  };

  const linkStyle = (isHovered) => ({
    color: isHovered ? '#b6b6b6' : 'white',
    fontSize: '30px',
    textDecoration: 'none',
    margin: '0 20px',
    transition: 'color 0.3s ease',
  });

  return (
    <div style={containerStyle}>
      <Helmet>
        <title>Homepage</title>
      </Helmet>
      <header style={headerStyle}>
        Troy Schwab
      </header>
      <div style={linkContainerStyle}>
        <Link
          to="/about"
          style={linkStyle(hovered === 'about')}
          onMouseEnter={() => setHovered('about')}
          onMouseLeave={() => setHovered(null)}
        >
          About
        </Link>
        <Link
          to="/photography"
          style={linkStyle(hovered === 'work')}
          onMouseEnter={() => setHovered('work')}
          onMouseLeave={() => setHovered(null)}
        >
          Photos
        </Link>
      </div>
      {imageError && (
        <div style={{ position: 'absolute', top: '20px', left: '20px', color: 'red' }}>
          {imageError}
        </div>
      )}

      {/* This is useful for testing to see what filename is being used as the background image */}
      
      {/* {backgroundImage && !imageError && (
        <div style={{ position: 'absolute', bottom: '20px', left: '20px', color: 'white' }}>
          <p>Current Background Image:</p>
          <p style={{ fontSize: '14px', fontWeight: 'bold' }}>{imageFilename}</p>
        </div>
      )} */}
    </div>
  );
};

export default HomePage;
